import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { PollFormQuestion, PollFormAnswers, PollFormDuration, PollFormFooter, } from './poll-form-content';
import { DeleteDialogContextWrapper, PollDataContextWrapper } from './contexts';
import { Styled } from './poll-form.styles';
export const PollForm = ({ onClose = () => { }, onDone, openDays = 7, options, question = '', }) => {
    React.useEffect(() => {
        var _a;
        // Remove the X button from the OmView
        const OmViewCrossIcon = (_a = document
            .querySelector('[data-xds="IconCross"]')) === null || _a === void 0 ? void 0 : _a.closest('button');
        if (OmViewCrossIcon)
            OmViewCrossIcon.style.display = 'none';
        return () => {
            if (OmViewCrossIcon)
                OmViewCrossIcon.style.display = 'initial';
        };
    }, []);
    return (_jsx(PollDataContextWrapper, { question, options, openDays, children: _jsx(DeleteDialogContextWrapper, { onClose, children: _jsxs(Styled.PollFormContainer, { children: [_jsx(Styled.PollFormHeader, { size: "xxlarge", id: "COMMBOX_POLLS_CREATE_BUTTON_LABEL" }), _jsx(PollFormQuestion, {}), _jsx(PollFormAnswers, {}), _jsx(PollFormDuration, {}), _jsx(PollFormFooter, { onDone })] }) }) }));
};
//# sourceMappingURL=poll-form.js.map